import { colors } from '@/constants/colors'
import * as React from 'react'
import Svg, { Rect } from 'react-native-svg'

const SelectionIndicator = ({
	height = 8,
	width = 104,
}: { height?: number | string; width?: number | string }) => (
	<Svg
		width={width}
		height={height}
		viewBox={'0 0 104 12'}
		fill="none"
		preserveAspectRatio="none"
	>
		<Rect x="0" y="4" width="104" height="4" fill={colors.ink} />
	</Svg>
)
export default SelectionIndicator
